export default "__VITE_ASSET__BBea1ERW__"